import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Ticker from './components/Ticker';
import QuickEntries from './components/QuickEntries';
import Timeline from './components/Timeline';
import HotRanking from './components/HotRanking';
import InsideStories from './components/InsideStories';
import Gallery from './components/Gallery';
import Entities from './components/Entities';
import TipSection from './components/TipSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <QuickEntries />
        <Timeline />
        <HotRanking />
        <InsideStories />
        <Gallery />
        <Entities />
        <TipSection />
      </main>
      <SiteFooter />
    </div>
  );
}